import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import { useTimeClockStore } from 'store/useTimeClockStore';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface IClockIn {
  user_id: string;
  job_id?: number;
  task_id?: number;
  latitude?: number;
  longitude?: number;
  notes?: string;
  speed?: number;
  timezone?: string;
  offset?: any;
  clock_in_time?: string;
}

const clockIn = (postData: IClockIn) => {
  return http().post(endpoints.timeClock.clockIn, postData);
};

export function useClockIn() {
  const addTimeClockDetails = useTimeClockStore(state => state.addTimeClockDetails);
  return useMutation({
    mutationFn: clockIn,
    onError: (errorData: any) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      toaster.error({ description: errorMessage });
    },
    onSuccess: ({ payload }) => {
      addTimeClockDetails(payload);
    },
  });
}
